module.exports = __webpack_public_path__ + "img/hello-black.653c2a95.svg";